module.exports = __webpack_public_path__ + "img/bannner.0dfba716.jpg";